import angular from "angular";
import { importFilesUnderPath, templateCacheGenerator } from "roblox-es6-migration-helper";

import "../../../css/resellers/resellers.scss";
import resellersModule from "./resellersModule";

importFilesUnderPath(require.context("./constants/", true, /\.js$/));
importFilesUnderPath(require.context("./services/", true, /\.js$/));
importFilesUnderPath(require.context("./controllers/", true, /\.js$/));
importFilesUnderPath(require.context("./components/", true, /\.js$/));

let templateContext = require.context("./", true, /\.html$/);

let templates = templateCacheGenerator(angular, "resellersAppTemplates", templateContext);

// self manual initialization
angular.element(function () {
    angular.bootstrap("#asset-resale-data-pane", [resellersModule.name]);
});

export default resellersModule;